module.exports = __webpack_public_path__ + "fonts/Libre_Franklin-300-latin3.c0aa69c.woff2";